import React, { useEffect, useState } from "react";
import { MdArrowOutward, MdOutlineLocalOffer } from "react-icons/md";
import { NumericFormat } from "react-number-format";

const EventCard = ({ event, toTitleCase, toggleDrawer, getUpcomingBatch }) => {
  const [date, setDate] = useState(null);

  useEffect(() => {

  if (event.batches?.length > 0) {
    console.log("inside condition");
    setDate(getUpcomingBatch(event.batches[0]));
  }
}, [event]);



  return (
    <div>
      <div className="card_item mb-4 lg-mb-2 p-lg-2">
        <div className="cla" onClick={() => toggleDrawer(event.slug)}>
          <div className="card cardradius ">
            <div style={{ backgroundImage: `url(${event.list_pic})`, backgroundSize: 'cover', height: '100%', backgroundPosition: 'center' }} className="whole-imgae">
              {/* <img
                src={event.list_pic}
                className="card-img-top"
                style={{borderRadius: '15px'}}
                alt="Event"
              /> */}
            </div>
            {event.event_card_tags && (
              <div
                className="ribbon-2"
                style={{
                  backgroundColor: event.style_data.backgroundColor,
                  color: event.style_data.textColor,
                }}
              >
                <div className="ribbon_heading">
                  <b className="event_tag">
                    {toTitleCase(event.event_card_tags)}
                  </b>
                </div>
              </div>
            )}
            {event.coupon && (
              <div>
                <div className="ribbon-offer" style={{ color: "black" }}>
                  <div className="offer_heading d-flex" style={{ gap: "4px" }}>
                    <MdOutlineLocalOffer size={20} />
                    <b className="event_tag">Offers Available!</b>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="card_body_height py-2">
            <div className="d-flex gap-2 w-100">
              {event.batches?.length > 0 && date && <div className="date_holder d-flex flex-column">
                <div className="day_holder date_gray px-3 mb-1">
                  {date.day}
                </div>
                <div className="d-flex date_ind flex-column align-items-center">
                  <span className="mb-0 date_hold">{date.date}</span>
                  <span className="mb-0 date_gray">{date.month}</span>
                </div>
              </div>}
              <div className="d-flex flex-column">
                <div>
                  <h6

                    className="card-title d-lg-block d-md-block d-none mb-0"
                    style={{
                      fontFamily: "",
                      fontSize: "14px",
                      maxWidth: '18rem',
                      lineHeight: '1'
                    }}
                  >
                    <b>{event.name}</b>
                  </h6>

                  <h6
                    className="card-title d-lg-none d-md-none d-block mb-0"
                    style={{
                      fontFamily: "",
                      fontSize: "14px",
                      maxWidth: '18rem',
                      lineHeight: '1'
                    }}
                  >
                    <b>
                      {/* {event.name.length > 18 ? event.name.substring(0, 16) + "..." : event.name} */}
                      {event.name}
                    </b>
                  </h6>
                </div>
                {event.batches.length > 1 ? <div className="line_height">
                  <span className="date_gray" style={{ fontSize: '12px' }}>+{event.batches.length - 1} more dates available</span>
                </div> : <div style={{ lineHeight: '1' }}>
                  <span className="date_gray" style={{ fontSize: '12px', lineHeight: '1' }}>Upcoming</span>
                </div>}
                <div
                  //   style={{ color: "white" }}
                  className="d-flex justify-content-between align-items-center"
                >
                  {/* <p className="text-detail-price mb-for-plain mb-0">{formatDate(event.batches)}</p> */}

                  {/* <div> */}
                  <span
                    className="text-detail-price mb-for-plain mb-0"
                    style={{
                      fontFamily: "",

                      fontWeight: "400",
                    }}
                  >
                    <span
                      className="me-2"
                      style={{
                        fontWeight: "300",
                        fontSize: "12px",
                        fontFamily: "",
                      }}
                    >
                      from
                    </span>
                    {event.price_striked ? (
                      <div className="d-inline-flex align-items-baseline">
                        <span style={{ fontSize: '14px' }}>&#8377;</span>
                        <NumericFormat
                          className="fw-bolder"
                          style={{
                            fontFamily: "",
                            fontSize: "14px",
                          }}
                          displayType="text"
                          type="text"
                          value={event.price}
                          thousandsGroupStyle="lakh"
                          thousandSeparator=","
                        />
                        <span
                          style={{ textDecoration: "line-through" }}
                          className="px-1 strike"
                        >
                          {event.price_striked}
                        </span>
                      </div>
                    ) : (<div className="d-inline-flex align-items-baseline">
                      <span style={{ fontSize: '14px' }}>&#8377;</span>
                      <NumericFormat
                        className="fw-bolder"
                        style={{
                          fontFamily: "",
                          fontSize: "14px",
                        }}
                        displayType="text"
                        type="text"
                        value={event.price}
                        thousandsGroupStyle="lakh"
                        thousandSeparator=","
                      />
                    </div>
                    )}
                  </span>
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventCard;
